const NumberFormatter = ({ amount, locale = "fa-IR",className }) => {
    const formattedNumber = new Intl.NumberFormat(locale).format(amount);
  
    return <span className={className}>{formattedNumber}</span>;
  };
  
  export default NumberFormatter;